"use client";
import * as React from "react";
const SvgBuildOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M15.78 13.09 9.15 6.48a4.7 4.7 0 0 0-1.05-5.1A4.76 4.76 0 0 0 1.94.91l2.8 2.8-1.03 1.03-2.8-2.79a4.7 4.7 0 0 0 .48 6.13 4.8 4.8 0 0 0 5.03 1.08l6.65 6.63a.73.73 0 0 0 1.03 0l1.68-1.68a.7.7 0 0 0 0-1.02m-2.19 1.16-6.9-6.88a3 3 0 0 1-1.47.6 3.27 3.27 0 0 1-3.76-3.42L3.72 6.8l3.1-3.09-2.26-2.25a3.3 3.3 0 0 1 2.5.96 3.3 3.3 0 0 1 .92 2.88 3 3 0 0 1-.65 1.43l6.9 6.87z" }));
export {
  SvgBuildOutlined as default
};
